export type AppView = 'dashboard' | 'tasks' | 'settings' | 'placeholder';

export interface SubItem {
  id: string;
  label: string;
  /**
   * P1 hierarchická route `/modul/sekce` (Dan 2026-05-30 - routing standard).
   * Modul = první úroveň URL, sekce = druhá. NE plochý `/modul-sekce`.
   */
  path: string;
  /**
   * Stará plochá route (dřívější P1 / prod tvar) - držena jako redirect/alias
   * kvůli kompatibilitě. pathToState ji matchne, URL se přepíše na `path`.
   */
  legacyPath?: string;
  view?: AppView;
}

export interface MenuItem {
  id: string;
  label: string;
  icon: string;
  view?: AppView;
  children?: SubItem[];
}

export const RONDO_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid', view: 'dashboard' },
  {
    id: 'provoz',
    label: 'Provoz',
    icon: 'activity',
    children: [
      { id: 'provoz-dashboard', label: 'Dashboard', path: '/provoz/dashboard', legacyPath: '/provoz-dashboard' },
    ],
  },
  // NOTE: Úkoly is NOT a Rondo-space module/category. It is a standalone,
  // cross-space module reached via the dedicated navbar button (nav-standalone
  // -btn → onOpenTasks) and lives at the top-level route `/ukoly`. It must NOT
  // appear under Provoz (or any space module). See AppShell Route kind 'tasks'.
  {
    id: 'uzivatele',
    label: 'Uživatelé',
    icon: 'users',
    children: [
      { id: 'uzivatele-prehled', label: 'Přehled', path: '/uzivatele/prehled', legacyPath: '/uzivatele-prehled' },
      { id: 'uzivatele-seznam', label: 'Seznam', path: '/uzivatele/seznam', legacyPath: '/uzivatele-seznam' },
      { id: 'uzivatele-vyplaty', label: 'Výplaty', path: '/uzivatele/vyplaty', legacyPath: '/uzivatele-vyplaty' },
      { id: 'uzivatele-segmentace', label: 'Segmentace', path: '/uzivatele/segmentace', legacyPath: '/uzivatele-segmentace' },
    ],
  },
  {
    id: 'produkty',
    label: 'Produkty',
    icon: 'package',
    children: [
      { id: 'produkty-prehled', label: 'Přehled', path: '/produkty/prehled', legacyPath: '/produkty-prehled' },
      { id: 'produkty-souteze', label: 'Soutěže', path: '/produkty/souteze', legacyPath: '/produkty-souteze' },
      { id: 'produkty-hry', label: 'Hry', path: '/produkty/hry', legacyPath: '/produkty-hry' },
      { id: 'produkty-tipovacka', label: 'Tipovačka', path: '/produkty/tipovacka', legacyPath: '/produkty-tipovacka' },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: 'dollar-sign',
    children: [
      { id: 'finance-uzivatele', label: 'Uživatelé', path: '/finance/uzivatele', legacyPath: '/finance-uzivatele' },
      { id: 'finance-reklamky', label: 'Reklamky', path: '/finance/reklamky', legacyPath: '/finance-reklamky' },
      { id: 'finance-affiliates', label: 'Affiliates', path: '/finance/affiliates', legacyPath: '/finance-affiliates' },
      { id: 'finance-trzby', label: 'GA Odhad tržeb', path: '/finance/trzby', legacyPath: '/finance-trzby' },
      { id: 'finance-trzby-real', label: 'Tržby z reklam', path: '/finance/trzby-real', legacyPath: '/finance-trzby-real' },
    ],
  },
  {
    id: 'aktivita',
    label: 'Aktivita',
    icon: 'trending-up',
    children: [
      { id: 'rondo-aktivita', label: 'Přehled', path: '/aktivita/prehled', legacyPath: '/rondo-aktivita' },
      { id: 'aktivita-navstevnost', label: 'Návštěvnost', path: '/aktivita/navstevnost', legacyPath: '/aktivita-navstevnost' },
      { id: 'aktivita-zobrazeni', label: 'Zobrazení', path: '/aktivita/zobrazeni', legacyPath: '/aktivita-zobrazeni' },
      { id: 'aktivita-cas', label: 'Čas', path: '/aktivita/cas', legacyPath: '/aktivita-cas' },
      { id: 'aktivita-opusteni', label: 'Opuštění', path: '/aktivita/opusteni', legacyPath: '/aktivita-opusteni' },
      { id: 'aktivita-produkty', label: 'Produkty', path: '/aktivita/produkty', legacyPath: '/aktivita-produkty' },
      { id: 'aktivita-seo', label: 'SEO (Ahrefs)', path: '/aktivita/seo', legacyPath: '/aktivita-seo' },
      { id: 'aktivita-vyhledavani', label: 'Vyhledávání (GSC)', path: '/aktivita/vyhledavani', legacyPath: '/aktivita-vyhledavani' },
      { id: 'marketing-behavioral', label: 'Behavioral', path: '/aktivita/behavioral', legacyPath: '/marketing-behavioral' },
    ],
  },
  {
    id: 'marketing',
    label: 'Marketing',
    icon: 'target',
    children: [
      { id: 'marketing-prehled', label: 'Přehled', path: '/marketing/prehled', legacyPath: '/marketing-prehled' },
      { id: 'marketing-kampane', label: 'Kampaně', path: '/marketing/kampane', legacyPath: '/marketing-kampane' },
      { id: 'marketing-sablony', label: 'Šablony', path: '/marketing/sablony', legacyPath: '/marketing-sablony' },
      { id: 'marketing-kanaly', label: 'Kanály', path: '/marketing/kanaly', legacyPath: '/marketing-kanaly' },
    ],
  },
];

const CRM_MODULE: MenuItem = {
  id: 'crm',
  label: 'CRM',
  icon: 'users',
  children: [
    { id: 'crm-leady', label: 'Leady', path: '/crm/leady' },
    { id: 'crm-pipeline', label: 'Pipeline', path: '/crm/pipeline' },
    { id: 'crm-formular', label: 'Formulář', path: '/crm/formular' },
  ],
};

export const CRM_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid', view: 'dashboard' },
  CRM_MODULE,
];

export const AFFILPLATFORM_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid', view: 'dashboard' },
  {
    id: 'klienti',
    label: 'Klienti',
    icon: 'target',
    children: [
      { id: 'ap-klienti-seznam', label: 'Seznam', path: '/klienti/seznam' },
    ],
  },
  CRM_MODULE,
  {
    id: 'mailing',
    label: 'Mailing',
    icon: 'mail',
    children: [
      { id: 'ap-mailing', label: 'Dashboard', path: '/mailing/prehled' },
      { id: 'ap-mailing-kampane', label: 'Kampaně', path: '/mailing/kampane' },
      { id: 'ap-mailing-skupiny', label: 'Skupiny', path: '/mailing/skupiny' },
      { id: 'ap-mailing-sablony', label: 'Šablony', path: '/mailing/sablony' },
    ],
  },
  {
    id: 'vystupy',
    label: 'Výstupy',
    icon: 'file-text',
    children: [
      { id: 'ap-vystupy-podpora', label: 'Podpora', path: '/vystupy/podpora' },
      { id: 'ap-vystupy-b2b', label: 'B2B', path: '/vystupy/b2b' },
      { id: 'ap-vystupy-vizitky', label: 'Vizitky', path: '/vystupy/vizitky' },
    ],
  },
];

export const DMWK_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid', view: 'dashboard' },
  {
    id: 'klienti',
    label: 'Klienti',
    icon: 'target',
    children: [
      { id: 'dmwk-klienti-seznam', label: 'Seznam', path: '/klienti/seznam' },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: 'dollar-sign',
    children: [
      { id: 'dmwk-vyuctovani-klienti', label: 'Vyúčtování Klienti', path: '/finance/vyuctovani-klienti' },
    ],
  },
];

export const AFFILMASTER_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid', view: 'dashboard' },
  {
    id: 'provoz',
    label: 'Provoz',
    icon: 'activity',
    children: [
      { id: 'am-provoz-dashboard', label: 'Dashboard', path: '/affilmaster/provoz' },
      { id: 'am-ukoly', label: 'Úkoly', path: '/affilmaster/ukoly' },
      { id: 'am-planovani', label: 'Plánování', path: '/affilmaster/planovani' },
    ],
  },
  {
    id: 'klienti',
    label: 'Klienti',
    icon: 'target',
    children: [
      { id: 'klienti-prehledy', label: 'Přehledy', path: '/affilmaster/klienti-prehledy' },
      { id: 'klienti-seznam', label: 'Seznam', path: '/affilmaster/klienti-seznam' },
    ],
  },
  {
    id: 'affiliates',
    label: 'Affiliates',
    icon: 'users',
    children: [
      { id: 'affiliates-prehledy', label: 'Přehledy', path: '/affilmaster/affiliates-prehledy' },
      {
        id: 'affiliates-seznam',
        label: 'Seznam',
        path: '/affilmaster/affiliates',
        legacyPath: '/affilmaster/affiliates-seznam',
      },
      { id: 'affiliates-segmentace', label: 'Segmentace', path: '/affilmaster/affiliates-segmentace' },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: 'dollar-sign',
    children: [
      { id: 'am-finance', label: 'Dashboard', path: '/affilmaster/finance' },
      { id: 'am-banka', label: 'Banka', path: '/affilmaster/banka' },
      { id: 'am-prijmy', label: 'Příjmy', path: '/affilmaster/prijmy' },
      { id: 'am-vyuc-partneri', label: 'Vyúčtování Klienti', path: '/affilmaster/vyuctovani-klienti', legacyPath: '/affilmaster/vyuctovani-partneri' },
      { id: 'am-vyuc-affiliates', label: 'Vyúčtování Affiliates', path: '/affilmaster/vyuctovani-affiliates' },
      { id: 'am-uol', label: 'UOL', path: '/affilmaster/uol' },
      { id: 'am-rozvaha', label: 'Uzávěrka', path: '/affilmaster/uzaverka', legacyPath: '/affilmaster/rozvaha' },
    ],
  },
  {
    id: 'crm',
    label: 'CRM',
    icon: 'users',
    children: [
      { id: 'am-crm-leady', label: 'Leady', path: '/affilmaster/crm/leady' },
      { id: 'am-crm-pipeline', label: 'Pipeline', path: '/affilmaster/crm/pipeline' },
      { id: 'am-crm-esign', label: 'eSign', path: '/affilmaster/crm/esign' },
      { id: 'am-crm-formular', label: 'Formulář', path: '/affilmaster/crm/formular' },
    ],
  },
  {
    id: 'mailing',
    label: 'Mailing',
    icon: 'mail',
    children: [
      { id: 'am-mailing', label: 'Dashboard', path: '/affilmaster/mailing/prehled' },
      { id: 'am-mailing-kampane', label: 'Kampaně', path: '/affilmaster/mailing/kampane', legacyPath: '/affilmaster/mailing-kampane' },
      { id: 'am-mailing-segmenty', label: 'Skupiny', path: '/affilmaster/mailing/skupiny', legacyPath: '/affilmaster/mailing/segmenty' },
      { id: 'am-mailing-sablony', label: 'Šablony', path: '/affilmaster/mailing/sablony' },
    ],
  },
  {
    id: 'vystupy',
    label: 'Výstupy',
    icon: 'file-text',
    children: [
      { id: 'am-vystupy-promo', label: 'Promo News', path: '/affilmaster/vystupy/promo-news' },
      { id: 'am-vystupy-podpora', label: 'Podpora', path: '/affilmaster/vystupy/podpora' },
      { id: 'am-vystupy-b2b', label: 'B2B', path: '/affilmaster/vystupy/b2b' },
      { id: 'am-vystupy-vizitky', label: 'Vizitky', path: '/affilmaster/vystupy/vizitky' },
    ],
  },
];
